import { usePageEvent } from '@bonnet/next/use-page-event';

import useCreateDealerDetailsPageEvent from '../../hooks/useCreateDealerDetailsPageEvent';

function DealerDetailsAnalyticsContainer() {
    const { onPageEnter, isServerRendered } = usePageEvent('ddpPage', { priority: 1 });
    const createDealerDetailsPageEvent = useCreateDealerDetailsPageEvent();

    onPageEnter(async () => {
        await createDealerDetailsPageEvent({ isInitialLoad: isServerRendered });
    });

    return null;
}

export default DealerDetailsAnalyticsContainer;
